<script>
import { shippingMethodLadProps, useShippingMethodLad } from "./mixin";

import AddressLadSelector from "@/containers/adresses-lad/adress-lad-selector";
import Planning from "@/containers/planning";
import AddressLadForm from "@/containers/adresses-lad/addresse-lad-form";
import Popin from "@/components/molecules/popin";
import Titre from "@/components/atoms/titre";
import Divider from "@/components/atoms/divider";
import ShippingMethodPhone from "@/containers/shipping-method/shipping-method-phone";
import AbonnementLadEuroDePlus from "@/containers/abonnement-lad/euro-de-plus";
import ChoixSacDrive from "@/components/organisms/choix-sac-drive";

export default {
  name: "ShippingMethodLad",
  components: {
    AddressLadSelector,
    Planning,
    AddressLadForm,
    Popin,
    Titre,
    Divider,
    ShippingMethodPhone,
    AbonnementLadEuroDePlus,
    ChoixSacDrive
  },
  props: {
    ...shippingMethodLadProps()
  },
  setup(props) {
    const { abonnementInCurrentMagasin, showBanniereEuroPlus, montantSac } =
      useShippingMethodLad(props);
    return { abonnementInCurrentMagasin, showBanniereEuroPlus, montantSac };
  },
  data() {
    return {
      addresseId: null,
      error: null
    };
  },
  methods: {
    showAddAdress() {
      this.$refs.popinAddAddress.show();
    },
    editAddress(id) {
      this.addresseId = id;
      this.$refs.popinAddAddress.show();
    },
    addresseLadSaved() {
      this.$refs.addressLadSelector.refresh();
      this.$refs.popinAddAddress.hide();
    }
  }
};
</script>

<template>
  <div class="u-pt-sm u-pl-md u-pr-md u-pb-md">
    <div
      v-if="showBanniereEuroPlus"
      class="u-pt-xs u-px-md u-pb-lg"
    >
      <AbonnementLadEuroDePlus :frais-livraison="tarifLad" />
    </div>
    <Popin
      ref="popinAddAddress"
      size="lg"
      aria-label="Adresse de livraison"
      @hidden="addresseId = null"
    >
      <h1 class="u-font-24 u-text-center u-color-primary u-mb-lg u-mb-none@sm u-p-sm@sm">
        <template v-if="!addresseId">
          Ajouter une adresse de livraison
        </template>
        <template v-else>
          Modifier une adresse de livraison
        </template>
      </h1>
      <AddressLadForm
        :addresse-id="addresseId"
        @cancel="$refs.popinAddAddress.hide()"
        @saved="addresseLadSaved()"
      />
    </Popin>

    <ChoixSacDrive
      v-if="consigneSacs"
      :is-offert="isSacOffert"
      :montant-sac="montantSac"
      class="u-px-md"
    />

    <AddressLadSelector
      ref="addressLadSelector"
      @addAddress="showAddAdress()"
      @editAddress="editAddress"
    />

    <template v-if="addresseLad">
      <ShippingMethodPhone
        v-if="eligibleAlerteSms"
        :error="error"
        is-lad
        class="u-mx-md u-mb-lg"
      />
      <div class="u-flex u-flex-align-center u-m-md">
        <Titre
          tag="h2"
          size="xs"
        >
          Créneau horaire
        </Titre>
        <Divider
          class="u-flex-item-fluid u-ml-xs"
          dotted
        />
      </div>
      <p class="u-mt-md u-mb-lg u-ml-md">
        Merci de choisir un créneau horaire de livraison
      </p>
      <Planning
        :service-id="service.id"
        :code-postal="addresseLad.attributes.code_postal"
        :code-insee="addresseLad.attributes.code_insee"
        :infos-legales="service.info_non_retrait"
        creneaux-full-width
        @error="(err) => {error = err}"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/schedule.scss";
</style>
